import styled from 'styled-components';

export const Container = styled.div`
  & .ant-radio-inner:after {
    all: initial;
  }
  padding: 1rem 1.5rem;
  background-color: ${({ theme }) => theme.colors.gray8};
  & > .hefesto-title {
    text-align: left;
    > h3 {
      color: ${({ theme }) => theme.colors.grayDark3};
      margin-bottom: 1rem;
    }
  }
  * > .ant-table-cell {
    :not(.ant-table-column-sorters) > span {
      font-size: 1rem;
      line-height: 1.5rem;
    }
  }
`;

export const NoProductsContainer = styled.div`
  font-family: ${({ theme }) => theme.fonts.workSans};
  font-size: 0.88rem;
  line-height: 1.38rem;
  font-weight: 400;
`;
